/* =========================================================
   GALIENOR — PAGES AVIS PRODUITS
   Titre dynamique + filtres notes + tri
   ========================================================= */

(function () {
  'use strict';

  const PRODUCT_NAMES = {
    '/pages/avis-surmena-day': 'SURMENA DAY',
    '/pages/avis-surmena-night': 'SURMENA NIGHT',
    '/pages/avis-intestinal-restore': 'INTESTINAL RESTORE',
    '/pages/avis-immuno-regul': 'IMMUNO REGUL',
    '/pages/avis-microbiote-clean': 'MICROBIOTE CLEAN',
    '/pages/avis-magnesium': 'Magnésium Bisglycinate',
    '/pages/avis-ashwagandha-ksm-66': 'Ashwagandha KSM-66®',
    '/pages/avis-omega-3-premium': 'Oméga 3 Premium',
    '/pages/avis-vitamine-d3-spray': 'Vitamine D3 Spray',
    '/pages/avis-acerola': 'Acérola 1000',
    '/pages/avis-hormonia-equilibre': 'HORMONIA ÉQUILIBRE',
    '/pages/avis-menocalm': 'MENOCALM+',
    '/pages/avis-collagene-marin-naticol': 'Collagène Marin Naticol®',
    '/pages/avis-l-glutamine': 'L-Glutamine',
    '/pages/avis-optipea-1200-pea': 'OptiPEA® 1200 PEA',
    '/pages/avis-libido': 'Libido',
    '/pages/avis-draineur-actif': 'Draineur Actif',

    '/pages/avis-pack-menopause': 'Pack Ménopause',
    '/pages/avis-pack-equilibre-hormonal-spm': 'Pack Équilibre Hormonal & SPM',
    '/pages/avis-pack-sibose': 'Pack Sibose',
    '/pages/avis-pack-stress-jour-nuit': 'Pack Stress Jour & Nuit',
    '/pages/avis-pack-stress-digestif': 'Pack Stress Digestif',
    '/pages/avis-pack-stress-immunite': 'Pack Stress & Immunité',
    '/pages/avis-pack-immuno-digestif': 'Pack Immuno Digestif'
  };

  const path = window.location.pathname.replace(/\/$/, '');
  const productName = PRODUCT_NAMES[path];

  if (!productName) return;

  function getRating(card) {
    const aria =
      card.getAttribute('aria-label') ||
      card.querySelector('[aria-label*="star"]')?.getAttribute('aria-label') ||
      '';

    const match = aria.match(/([1-5])\s*stars?/i);

    if (match) return parseInt(match[1], 10);

    const filled = card.querySelectorAll('.jm-star-rating__filled').length;

    return filled || 0;
  }

  function findLoadMore(widget) {
    const candidates = widget.querySelectorAll('button, a');

    for (const element of candidates) {
      const text = (element.textContent || '').trim().toLowerCase();

      if (
        text.includes('afficher plus') ||
        text.includes('show more') ||
        text.includes('load more')
      ) {
        return element;
      }
    }

    return null;
  }

  async function loadAllReviews(widget) {
    let previousCount = 0;
    let attemptsWithoutChange = 0;

    for (let i = 0; i < 30; i++) {
      const cards = widget.querySelectorAll('.jdgm-review-card');
      const currentCount = cards.length;

      if (currentCount === previousCount) {
        attemptsWithoutChange++;
      } else {
        attemptsWithoutChange = 0;
      }

      previousCount = currentCount;

      const button = findLoadMore(widget);

      if (!button || attemptsWithoutChange >= 3) break;

      button.classList.add('galienor-native-load-more');
      button.click();

      await new Promise(resolve => setTimeout(resolve, 650));
    }

    widget.classList.add('galienor-all-loaded');
  }

  function replaceTitle(widget) {
  const walker = document.createTreeWalker(
    widget,
    NodeFilter.SHOW_TEXT
  );

  let node;

  while ((node = walker.nextNode())) {
    if ((node.nodeValue || '').trim() === 'De nos clients') {
      node.nodeValue = 'Avis clients ' + productName;

      const heading = node.parentElement;

      if (heading) {
        heading.classList.add('galienor-reviews-heading');

        if (heading.parentElement) {
          heading.parentElement.classList.add('galienor-reviews-header');
        }
      }

      break;
    }
  }
}

  function buildTools(widget, cards) {
    if (document.querySelector('.galienor-reviews-tools')) return;

    const ratingsAvailable = new Set();

    cards.forEach(card => {
      const rating = getRating(card);
      if (rating) ratingsAvailable.add(rating);
    });

    const tools = document.createElement('div');
    tools.className = 'galienor-reviews-tools';

    const filters = document.createElement('div');
    filters.className = 'galienor-reviews-filters';

    const allButton = document.createElement('button');
    allButton.type = 'button';
    allButton.className = 'galienor-review-filter is-active';
    allButton.dataset.rating = 'all';
    allButton.textContent = 'Tous les avis';

    filters.appendChild(allButton);

    [5, 4, 3, 2, 1].forEach(rating => {
      if (!ratingsAvailable.has(rating)) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'galienor-review-filter';
      button.dataset.rating = String(rating);
      button.textContent = rating + '★';

      filters.appendChild(button);
    });

    const sortWrap = document.createElement('div');
    sortWrap.className = 'galienor-reviews-sort';

    const label = document.createElement('label');
    label.textContent = 'Trier par';

    const select = document.createElement('select');

    select.innerHTML = `
      <option value="recent">Plus récents</option>
      <option value="high">Mieux notés</option>
      <option value="low">Moins bien notés</option>
    `;

    sortWrap.appendChild(label);
    sortWrap.appendChild(select);

    tools.appendChild(filters);
    tools.appendChild(sortWrap);

    const firstCard = cards[0];

    if (firstCard) {
      const cardContainer = firstCard.parentElement;
      cardContainer.parentElement.insertBefore(tools, cardContainer);
    }

    const empty = document.createElement('div');
    empty.className = 'galienor-review-empty';
    empty.textContent = 'Aucun avis ne correspond à ce filtre.';

    tools.insertAdjacentElement('afterend', empty);

    return {
      filters,
      select,
      empty
    };
  }

  function initialiseFiltering(widget) {
    const cards = Array.from(widget.querySelectorAll('.jdgm-review-card'));

    if (!cards.length) return;

    const container = cards[0].parentElement;

    cards.forEach((card, index) => {
      card.dataset.galienorRating = String(getRating(card));
      card.dataset.galienorOriginalOrder = String(index);
    });

    const ui = buildTools(widget, cards);

    if (!ui) return;

    let activeRating = 'all';

    function apply() {
      const sortedCards = Array.from(
        widget.querySelectorAll('.jdgm-review-card')
      );

      if (ui.select.value === 'high') {
        sortedCards.sort((a, b) =>
          Number(b.dataset.galienorRating) -
          Number(a.dataset.galienorRating)
        );
      }

      if (ui.select.value === 'low') {
        sortedCards.sort((a, b) =>
          Number(a.dataset.galienorRating) -
          Number(b.dataset.galienorRating)
        );
      }

      if (ui.select.value === 'recent') {
        sortedCards.sort((a, b) =>
          Number(a.dataset.galienorOriginalOrder) -
          Number(b.dataset.galienorOriginalOrder)
        );
      }

      sortedCards.forEach(card => container.appendChild(card));

      let visible = 0;

      sortedCards.forEach(card => {
        const show =
          activeRating === 'all' ||
          card.dataset.galienorRating === activeRating;

        card.style.display = show ? '' : 'none';

        if (show) visible++;
      });

      ui.empty.classList.toggle('is-visible', visible === 0);
    }

    ui.filters.addEventListener('click', event => {
      const button = event.target.closest('.galienor-review-filter');

      if (!button) return;

      activeRating = button.dataset.rating;

      ui.filters
        .querySelectorAll('.galienor-review-filter')
        .forEach(item => item.classList.remove('is-active'));

      button.classList.add('is-active');

      apply();
    });

    ui.select.addEventListener('change', apply);

    apply();
  }
function initialiseReadMore(widget) {

  const cards = widget.querySelectorAll('.jdgm-review-card');

  cards.forEach(card => {

    if (card.dataset.galienorReadMoreReady === 'true') return;

    const description = card.querySelector(
      '.jdgm-review-card__details-description'
    );

    if (!description) return;

    card.dataset.galienorReadMoreReady = 'true';

    requestAnimationFrame(() => {

      const needsToggle =
        description.scrollHeight > description.clientHeight + 3;

      if (!needsToggle) return;

      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'galienor-review-toggle';
      button.textContent = 'Lire la suite ↓';
      button.setAttribute('aria-expanded', 'false');

      description.insertAdjacentElement('afterend', button);

      button.addEventListener('click', event => {

        event.preventDefault();
        event.stopPropagation();

        const expanded =
          card.classList.toggle('galienor-review-expanded');

        button.textContent =
          expanded
            ? 'Réduire ↑'
            : 'Lire la suite ↓';

        button.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );

      });

    });

  });

}
  async function init() {
    const widget = document.querySelector('.jdgm-reviews-grid-widget');

    if (!widget) return;

    replaceTitle(widget);

    /*
     * Judge.me est configuré sur "Most recent".
     * On charge donc d'abord tous les avis du produit.
     * L'ordre initial devient notre référence "Plus récents".
     */
    await loadAllReviews(widget);

    replaceTitle(widget);

initialiseFiltering(widget);
initialiseReadMore(widget);
  }

  function waitForJudgeMe() {
    const widget = document.querySelector('.jdgm-reviews-grid-widget');

    if (widget && widget.querySelector('.jdgm-review-card')) {
      init();
      return;
    }

    setTimeout(waitForJudgeMe, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForJudgeMe);
  } else {
    waitForJudgeMe();
  }

})();